module.exports = __webpack_public_path__ + "img/Taiwan.46dff59b.jpg";